import BaseChannel from "./BaseChannel";

export default class LegacyPublicAccountChannel extends BaseChannel {
  static channelName = "LegacyPublicAccountChannel";
}
